import { ButtonHTMLAttributes } from "react";
import { Trash2 } from "lucide-react";
import { IconButton } from "./IconButton";

const variantStyles = {
  primary: "border border-primary-200 dark:border-primary-800 text-primary-950 dark:text-white hover:border-primary-400 dark:hover:border-primary-600",
  secondary: "border border-primary-200 dark:border-primary-800 text-primary-950 dark:text-white hover:border-primary-400 dark:hover:border-primary-600",
  destructive: "border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 hover:border-red-400 dark:hover:border-red-600",
};

const iconSizes = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-6 w-6" };

export interface DeleteIconButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "aria-label"> {
  "aria-label"?: string;
  variant?: "primary" | "secondary" | "destructive";
  iconSize?: "sm" | "md" | "lg";
  className?: string;
  /** Optional label: icon only on small screens, icon + label on sm+ */
  label?: string;
}

export function DeleteIconButton({
  "aria-label": ariaLabel = "Excluir",
  variant = "destructive",
  iconSize = "md",
  className = "",
  label,
  ...props
}: DeleteIconButtonProps) {
  const variantStyle = variantStyles[variant];
  const iconSizeClass = iconSizes[iconSize];
  const baseClasses = "inline-flex items-center gap-1.5 px-3 py-2 transition-colors duration-300 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50";

  if (label != null && label !== "") {
    const classes = `${baseClasses} ${variantStyle} ${className}`.trim();
    return (
      <button type="button" aria-label={ariaLabel} className={classes} {...props}>
        <Trash2 className={iconSizeClass} strokeWidth={1.5} />
        <span className="hidden sm:inline text-sm uppercase tracking-widest">{label}</span>
      </button>
    );
  }

  return (
    <IconButton
      variant={variant}
      aria-label={ariaLabel}
      iconSize={iconSize}
      className={className}
      {...props}
    >
      <Trash2 strokeWidth={1.5} />
    </IconButton>
  );
}
